/** Habitat-free JSON object probe for external input. */
export class kJsonObject {
    /** DOCUMENTED EXCEPTION: pure parse probe; malformed input is a normal fallback, even in error mode. */
    public static ObjectOfJson = (Json: string, Fallback: Record<string, unknown> | null = null): Record<string, unknown> | null => {
        try {
            if (typeof Json !== "string" || Json.trim().length === 0) { return Fallback; }
            const Raw: unknown = JSON.parse(Json);
            if (Raw === null || typeof Raw !== "object" || Array.isArray(Raw) === true) { return Fallback; }
            return Raw as Record<string, unknown>;
        } catch (e) {
            // ERROR-SUPPRESSED-JUSTIFIED: invalid external JSON is the defined fallback, not a defect.
            return Fallback;
        }
    };
}
